require('../../modules/es6.string.iterator');
require('../../modules/web.dom.iterable');
module.exports = require('../../modules/_wks-ext').f('iterator');



//////////////////
// WEBPACK FOOTER
// ./~/react-input-calendar/~/core-js/library/fn/symbol/iterator.js
// module id = 1256
// module chunks = 3